// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"gL_j7uQd","content":"_35lpQmmG","cards-container":"eqIft-Vn","challenge-container":"_3EZyElpS"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/components/MediumGrid/MediumGrid.styl
// module id = 245
// module chunks = 0